import { NEW_DOCUMENT_URL } from "app/modules/upload/new-document/new-document-list";

export const BASE_REQUEST_CONSTANT = {
    PIVOT_PAGING: NEW_DOCUMENT_URL.PIVOT_PAGING + "?hierarchical=false&starredOnly=false&sharedLinkOnly=false",
    PIVOT_COUNT: NEW_DOCUMENT_URL.PIVOT_COUNT + "?hierarchical=false&starredOnly=false&sharedLinkOnly=false",
};